module.exports = __webpack_public_path__ + "static/media/Keshavarzi.16e696de.svg";